import { journeyAction, } from './base';

import { JourneyActionVoiceHangup as JourneyActionVoiceHangupBase, } from 'atlas-shared';

export const JourneyActionVoiceHangup = journeyAction({
  ...JourneyActionVoiceHangupBase,
  icon: 'Hangup',
});
